import {
  IStandardTranscript,
  IStandardTranscriptResult,
  IStandardTranscriptWord,
} from '../interfaces/standard-transcript.interface';

export enum EChannel {
  user,
  agent,
}

export interface IStandardParagraphNormalized {
  channel: EChannel;
  words: IStandardTranscriptWord[];
}

export interface IStandardTranscriptNormalized {
  startDate: string;
  conversationSummary: string;
  paragraphs: IStandardParagraphNormalized[];
}

export class StandardTranscriptNormalizedModel implements IStandardTranscriptNormalized {
  startDate: string = '';
  conversationSummary: string = '';
  paragraphs: IStandardParagraphNormalized[] = [];

  constructor(data?: IStandardTranscript) {
    if (data) {
      const { startDate, paragraphs, conversationSummary } = this.normalize(data);
      this.startDate = startDate;
      this.conversationSummary = conversationSummary;
      this.paragraphs = paragraphs;
    }
  }

  private normalize(data: IStandardTranscript): IStandardTranscriptNormalized {
    const { startDate, conversationSummary } = data;
    const paragraphs = this.extractParagraphs(data.transcript.results);

    return { startDate, paragraphs, conversationSummary };
  }

  private extractParagraphs({
    paragraphs: { paragraphs },
    channels,
  }: IStandardTranscriptResult): IStandardParagraphNormalized[] {
    const normalizedParagraphs: IStandardParagraphNormalized[] = [];

    for (let i = 0; i < paragraphs.length; i++) {
      const paragraphWordCount = paragraphs[i].numWords;
      const currentChannel = paragraphs[i].channel;
      const allChannelWords = channels[currentChannel].alternatives[0].words;
      const paragraphWords = allChannelWords.splice(0, paragraphWordCount);

      this.updateNormalizedParagraphs(normalizedParagraphs, paragraphWords, currentChannel);
    }

    return normalizedParagraphs;
  }

  private updateNormalizedParagraphs(
    normalizedParagraphs: IStandardParagraphNormalized[],
    words: IStandardTranscriptWord[],
    channel: EChannel,
  ): void {
    const prevParagraph = normalizedParagraphs[normalizedParagraphs.length - 1];

    if (prevParagraph?.channel === channel) {
      prevParagraph.words.push(...words);
    } else {
      normalizedParagraphs.push({ words, channel });
    }
  }
}
